import React from 'react';

// Direct-host the MP4 from /public so we don't depend on YouTube. ~8 MB,
// served via Vercel CDN.
export const DEMO_VIDEO_URL = '/demo.mp4';

// Back-compat export — some imports still reference the old name.
export const DEMO_YOUTUBE_URL = DEMO_VIDEO_URL;

export function youtubeEmbedUrl(url) {
  if (!url) return '';
  const short = url.match(/youtu\.be\/([\w-]{6,15})/);
  if (short) return `https://www.youtube.com/embed/${short[1]}?autoplay=1&rel=0&modestbranding=1`;
  const long = url.match(/[?&]v=([\w-]{6,15})/);
  if (long)  return `https://www.youtube.com/embed/${long[1]}?autoplay=1&rel=0&modestbranding=1`;
  const embed = url.match(/youtube\.com\/embed\/([\w-]{6,15})/);
  if (embed) return `https://www.youtube.com/embed/${embed[1]}?autoplay=1&rel=0&modestbranding=1`;
  return url;
}

function isDirectVideo(url) {
  return /\.(mp4|webm|mov)(\?|$)/i.test(url || '');
}

const DEMO_CSS = `
  @keyframes ckDemoFade { from { opacity: 0; transform: scale(0.96); } to { opacity: 1; transform: scale(1); } }
`;

export default function DemoModal({ open, onClose, url = DEMO_VIDEO_URL, title = 'CreatorKhata — Product Demo' }) {
  if (!open) return null;

  const directVideo = isDirectVideo(url);

  return (
    <>
      <style>{DEMO_CSS}</style>
      <div
        onClick={onClose}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(6px)',
          zIndex: 2000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '1.5rem',
        }}
      >
        <div
          onClick={e => e.stopPropagation()}
          style={{
            background: '#0f1117', borderRadius: '20px',
            width: '100%', maxWidth: '900px',
            boxShadow: '0 30px 80px rgba(0,0,0,0.5)',
            overflow: 'hidden',
            animation: 'ckDemoFade 0.25s ease',
          }}
        >
          <div style={{ background: 'linear-gradient(135deg,#0f1117,#1a2535)', padding: '0.85rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.55rem' }}>
              <span style={{ width: 26, height: 26, borderRadius: '8px', background: 'linear-gradient(135deg,#6366f1,#ec4899)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', color: 'white' }}>▶</span>
              <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: '0.95rem', color: 'white' }}>
                {title}
              </div>
            </div>
            <button
              onClick={onClose}
              aria-label="Close demo video"
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: 'none', borderRadius: '8px',
                color: 'rgba(255,255,255,0.75)',
                width: 32, height: 32, cursor: 'pointer',
                fontSize: '0.95rem',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              ✕
            </button>
          </div>

          <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', background: '#000' }}>
            {directVideo ? (
              <video
                src={url}
                controls
                autoPlay
                playsInline
                preload="metadata"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0, background: '#000' }}
              />
            ) : (
              <iframe
                src={youtubeEmbedUrl(url)}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
